import { isSequential } from './isSequential';

export const isMinLowerCaseValid = (pwd: string, min: number): boolean => {
  const lowerCases = pwd.match(/[a-z]/g);
  return !!lowerCases && lowerCases.length >= min;
};

export const isMinUpperCaseValid = (pwd: string, min: number): boolean => {
  const upperCases = pwd.match(/[A-Z]/g);
  return !!upperCases && upperCases.length >= min;
};

export const isMinNumericsValid = (pwd: string, min: number): boolean => {
  const digits = pwd.match(/[0-9]/g);
  return !!digits && digits.length >= min;
};

export const isMinSymbolsValid = (pwd: string, min: number): boolean => {
  const symbols = pwd.match(/[^A-Za-z 0-9]/g);
  return !!symbols && symbols.length >= min;
};

export const isMaxRepeatingCharactersValid = (pwd: string, max: number): boolean => {
  if (max <= 0) {
    return true;
  }

  const list = pwd.match(/(.)\1*/g);

  return !list || list.every((char) => char.length <= max);
};

export const isMaxSequentialCharactersValid = (pwd: string, max: number): boolean => {
  if (max <= 0) {
    return true;
  }

  return isSequential(pwd, max) && isSequential(pwd.split('').reverse().join(''), max);
};

export const isUserNameInPasswordValid = (pwd: string, name: string): boolean => {
  return !isValueIncludedInPassword(pwd, name);
};

export const isEmployeeInfoInPasswordValid = (
  pwd: string,
  info: {
    employeeCode?: string;
    payrollCode?: string;
    firstName?: string;
    lastName?: string;
  },
): boolean => {
  const { employeeCode, payrollCode, lastName, firstName } = info;

  return (
    !isValueIncludedInPassword(pwd, employeeCode) &&
    !isValueIncludedInPassword(pwd, payrollCode) &&
    !isValueIncludedInPassword(pwd, firstName) &&
    !isValueIncludedInPassword(pwd, lastName)
  );
};

const isValueIncludedInPassword = (pwd: string, value?: string): boolean => {
  return !!value && pwd.toLowerCase().includes(value.toLowerCase());
};
